import { createContext, useContext, useState } from "react";
import defaultFlowConfig from "../config/flowConfig";
import defaultQuestions from "../config/questions";

export const ConfigContext = createContext();

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const [partnerName, setPartnerName] = useState("glueckauf-skin");
  const configData = defaultFlowConfig;
  const logo = "logo.png";
  const userQuestions = defaultQuestions;

  const updatePartnerName = (newPartnerName) => setPartnerName(newPartnerName);

  return (
    <ConfigContext.Provider
      value={{
        logo,
        configData,
        userQuestions,
        partnerName,
        updatePartnerName,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
